// extracted by mini-css-extract-plugin
module.exports = {"header":"contacts_header__1ikDP","line":"contacts_line__2-AxT","boxFlex":"contacts_boxFlex__2OSlX"};